module.exports = __webpack_public_path__ + "static/media/davide-berruto-photo-1.94521f99.jpg";